const exact = new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** 7000 -> "70,00 lei" */
export const formatLeiExact = (bani) => `${exact.format((bani || 0) / 100)} lei`;

const DAY_MS = 24 * 60 * 60 * 1000;

/** Data la care ar expira accesul dacă plata se face acum (estimare; serverul decide). Zile fixe, nu luni. */
export const estimateExpiry = (currentExpiryIso, days = 30) => {
  const now = Date.now();
  const current = currentExpiryIso ? new Date(currentExpiryIso).getTime() : null;
  const base = current && current > now ? current : now;
  return new Date(base + days * DAY_MS).toISOString();
};
